import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const AnnotationSourceSchema = BaseSchema.extend({
  position: FlatModels.PointSharedModels.PointSchema,
  zoom: z.number().nullable().default(null),
  startType: FlatModels.AnnotationEntityModels.TipType.nullable().default(FlatModels.AnnotationEntityModels.TipType.enum.dot),
  annotation: z.string().uuid().optional()
});

export type AnnotationSource = z.infer<typeof AnnotationSourceSchema>;

export const AnnotationSourceEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: AnnotationSourceSchema,
});

export type AnnotationSourceEntityQueryResult = z.infer<typeof AnnotationSourceEntityQueryResultSchema>;
